/**
 * Created with IntelliJ IDEA.
 * User: omerh
 * Date: 5/7/13
 * Time: 2:08 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var Template = require("templates/personaSwitcher.tmpl");
    var CONST = require("const");

    var PersonaSwitcherItemView = require("personaSwitcherItemView");
    var PersonaSwitcher;
    PersonaSwitcher = Marionette.CompositeView.extend({
        itemViewContainer : ".personaSwitcher",
        itemView : PersonaSwitcherItemView,
        tagName : "div",
        template : Template,
        ui : {
            notification : ".notification"
        },
        initialize : function (options) {
            this.LE = options.application;
            this.itemViewOptions = {
                application : options.application
            };
        },
        onRender : function () {
            //in case of single persona
            if (this.collection.length <= 1 && !this.isShowAlways()) {
                this.$el.toggle(false); //hide
            }
        },
        setSwitcher : function (switcherControl) {
            $(this.$itemViewContainer.children()).removeClass("on");
            var switcherItems = this.$(".switcher-item");
            switcherItems.removeClass("on");
            switcherItems.addClass("off");
            var switcherControlEl = this.$(switcherControl);
            if (switcherControlEl) {
                //switcherControlEl.toggleClass("on off");
                switcherControlEl.addClass("on");
            }
            else {
                this.LE.logger.error("Error. Trying to switch to wrong switcher Control");
                this.LE.logger.graph({name:"framework:PersonaSwitcher:errorTryingToSwitchToWrongWwitcher"});
            }
        },
        isShowAlways : function () {
            return this.LE.sessionManager.hasPersona(CONST.PERSONA.AGENT); //in case of one persona that is an agent- show it
        }
    });
    return PersonaSwitcher;
});

